import React from "react";
import StaticLayout from "../../layouts/static-layout";
import PhoneMockup from "../../components/landing/phone-mockup";
import { StoreButtons } from "../../components/landing/footer";

export default function DownloadPage() {
  return (
    <StaticLayout>
      <section className="mx-auto grid w-[92%] max-w-[1100px] items-center gap-12 py-16 lg:grid-cols-2 lg:py-24">
        <div className="space-y-6">
          <h1 className="text-4xl font-extrabold tracking-tight text-primary-dark lg:text-5xl">Download our app</h1>
          <p className="max-w-[480px] text-lg text-[#5b5f73]">
            Recharge your meter, pay bills and manage access codes from your phone.
          </p>
          <StoreButtons />
        </div>
        <PhoneMockup />
      </section>
    </StaticLayout>
  );
}
